import { render, staticRenderFns } from "./PostedInventory.vue?vue&type=template&id=13bfd068&"
import script from "./PostedInventory.vue?vue&type=script&lang=js&"
export * from "./PostedInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports